import Login from "../screens/nonAuth/Login";
import Register from "../screens/nonAuth/Register";
import Dashboard from "../screens/auth/Dashboard";
import Home from "../screens/users/Home";
import About from "../screens/users/About";
import Contact from "../screens/users/Contact";
import ForgotPassword from "../screens/nonAuth/ForgotPassword";
import Blogs from "../screens/auth/Blogs";
import Articles from "../screens/auth/Articles";
import ArticlesDetails from "../screens/auth/ArticlesDetails";
import ServicesDetails from "../screens/users/ServicesDetails";
import BlogList from "../screens/users/BlogList";
import EditBlogModal from "../components/modals/EditBlogModal";
import EditArticleModal from "../components/modals/EditArticleModal";
import Services from "../screens/auth/Services";
import SubService from "../screens/auth/SubService";
import SubserviceDetails from "../components/services-details/SubserviceDetails";
import Banner from "../screens/auth/Banner";
import BlogDetails from "../components/userblog/BlogDetails";
import UserarticleDetails from "../components/userarticle/UserarticleDetails";
import HomePage from "../screens/auth/HomePage";
import AuthSubSubService from "../screens/auth/AuthSubSubService";
import SubSubService from "../components/services-details/SubSubServiceDetails";
import Aboutpage from "../screens/auth/Aboutpage";
import Profile from "../screens/auth/Profile";
import Inquiry from "../screens/auth/Inquiry";
import OurClient from "../screens/auth/OurClient";
import DownloadsAdmin from "../screens/auth/DownloadsAdmin";
import ServicesPage from "../screens/users/Servicespage";
import ArticlesPage from "../screens/users/Articlespage";
import AssociatePage from "../screens/auth/AssociatePage";
import SubSubServiceDetails from "../components/services-details/SubSubServiceDetails";

export const authRoutes = [
  {
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/blogs",
    component: <Blogs />,
  },
  {
    path: "/blogs-edit/:id",
    component: <EditBlogModal />,
  },
  {
    path: "/articles",
    component: <Articles />,
  },
  {
    path: "/services",
    component: <Services />,
  },
  {
    path: "/subservices",
    component: <SubService />,
  },
  {
    path: "/articles-edit/:id",
    component: <EditArticleModal />,
  },
  {
    path: "/articles-details/:id",
    component: <ArticlesDetails />,
  },
  {
    path: "/banner",
    component: <Banner />,
  },
  {
    path: "/subsubservice",
    component: <AuthSubSubService />,
  },
  {
    path: "/homepage",
    component: <HomePage />,
  },
  {
    path: "/aboutpage",
    component: <Aboutpage />,
  },
  {
    path: "/profile",
    component: <Profile />,
  },
  {
    path: "/inquiry",
    component: <Inquiry />,
  },
  {
    path: "/associate",
    component: <AssociatePage />,
  },
  {
    path: "/our-client",
    component: <OurClient />,
  },
  {
    path: "/download",
    component: <DownloadsAdmin />,
  },
];

export const nonAuthRoutes = [
  {
    path: "/login",
    component: <Login />,
  },
  {
    path: "/register",
    component: <Register />,
  },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
  },
];

export const userRoutes = [
  // Home page
  {
    path: "/",
    component: <Home />,
  },
  
  // About page
  {
    path: "/about",
    component: <About />,
  },
  
  // Contact page
  {
    path: "/contact",
    component: <Contact />,
  },
  
  // Services with SEO-friendly URLs
  {
    path: "/services/:slug",
    component: <ServicesDetails />,
  },
  
  // ✅ NEW SEO-friendly Subservice route (using slug)
  {
    path: "/sub-service/:slug",
    component: <SubserviceDetails />,
  },
  {
    path: "/services/:slug/sub-service/:subSlug",
    component: <SubserviceDetails />,
  },
  
  // ✅ NEW SEO-friendly SubSubService routes
  {
    path: "/sub-subservice/:slug",
    component: <SubSubServiceDetails />,
  },
  {
    path: "/services/:slug/sub-service/:subSlug/:subSubSlug",
    component: <SubSubServiceDetails />,
  },
  
  // Blog routes with SEO-friendly URLs
  {
    path: "/blog-list",
    component: <BlogList />,
  },
  {
    path: "/blog/:slug",
    component: <BlogDetails />,
  },
  
  // Article routes with SEO-friendly URLs
  {
    path: "/all-article",
    component: <ArticlesPage />,
  },
  {
    path: "/article/:slug",
    component: <UserarticleDetails />,
  },
  
  // ✅ LEGACY SUPPORT (using ID - for backward compatibility)
  {
    path: "/blog/id/:id",
    component: <BlogDetails />,
  },
  {
    path: "/article/id/:id",
    component: <UserarticleDetails />,
  },
  {
    path: "/service-details/:id",
    component: <ServicesDetails />,
  },
  {
    path: "/sub-service-details/:id",  
    component: <SubserviceDetails />,
  },
  {
    path: "/sub-subservice-details/:id", 
    component: <SubSubServiceDetails />,
  },
];

// import Login from "../screens/nonAuth/Login";
// import Register from "../screens/nonAuth/Register";
// import Dashboard from "../screens/auth/Dashboard";
// import Home from "../screens/users/Home";
// import About from "../screens/users/About";
// import Contact from "../screens/users/Contact";
// import ForgotPassword from "../screens/nonAuth/ForgotPassword";
// import Blogs from "../screens/auth/Blogs";
// import Articles from "../screens/auth/Articles";
// import ArticlesDetails from "../screens/auth/ArticlesDetails";
// import ServicesDetails from "../screens/users/ServicesDetails";
// import BlogList from "../screens/users/BlogList";
// import EditBlogModal from "../components/modals/EditBlogModal";
// import EditArticleModal from "../components/modals/EditArticleModal";
// import Services from "../screens/auth/Services";
// import SubService from "../screens/auth/SubService";
// import SubserviceDetails from "../components/services-details/SubserviceDetails";
// import Banner from "../screens/auth/Banner";
// import BlogDetails from "../components/userblog/BlogDetails";
// import UserarticleDetails from "../components/userarticle/UserarticleDetails";
// import HomePage from "../screens/auth/HomePage";
// import AuthSubSubService from "../screens/auth/AuthSubSubService";
// import SubSubService from "../components/services-details/SubSubServiceDetails";
// import Aboutpage from "../screens/auth/Aboutpage";
// import Profile from "../screens/auth/Profile";
// import Inquiry from "../screens/auth/Inquiry";
// import OurClient from "../screens/auth/OurClient";
// import DownloadsAdmin from "../screens/auth/DownloadsAdmin";
// import ServicesPage from "../screens/users/Servicespage";
// import ArticlesPage from "../screens/users/Articlespage";
// import AssociatePage from "../screens/auth/AssociatePage";

// export const authRoutes = [
//   {
//     path: "/dashboard",
//     component: <Dashboard />,
//   },
//   {
//     path: "/blogs",
//     component: <Blogs />,
//   },
//   {
//     path: "/blogs-edit/:id",
//     component: <EditBlogModal />,
//   },
//   {
//     path: "/articles",
//     component: <Articles />,
//   },
//   {
//     path: "/services",
//     component: <Services />,
//   },
//   {
//     path: "/subservices",
//     component: <SubService />,
//   },
//   {
//     path: "/articles-edit/:id",
//     component: <EditArticleModal />,
//   },
//   {
//     path: "/articles-details/:id",
//     component: <ArticlesDetails />,
//   },
//   {
//     path: "/banner",
//     component: <Banner />,
//   },
//   {
//     path: "/subsubservice",
//     component: <AuthSubSubService />,
//   },
//   {
//     path: "/homepage",
//     component: <HomePage />,
//   },
//   {
//     path: "/aboutpage",
//     component: <Aboutpage />,
//   },
//   {
//     path: "/profile",
//     component: <Profile />,
//   },
//   {
//     path: "/inquiry",
//     component: <Inquiry />,
//   },
//   {
//     path: "/associate",
//     component: <AssociatePage />,
//   },
//   {
//     path: "/our-client",
//     component: <OurClient />,
//   },
//   {
//     path: "/download",
//     component: <DownloadsAdmin />,
//   },
// ];

// export const nonAuthRoutes = [
//   {
//     path: "/login",
//     component: <Login />,
//   },
//   {
//     path: "/register",
//     component: <Register />,
//   },
//   {
//     path: "/forgot-password",
//     component: <ForgotPassword />,
//   },
// ];

// export const userRoutes = [
//   // Home page
//   {
//     path: "/",
//     component: <Home />,
//   },
  
//   // About page
//   {
//     path: "/about",
//     component: <About />,
//   },
  
//   // Contact page
//   {
//     path: "/contact",
//     component: <Contact />,
//   },
  
//   // Services with SEO-friendly URLs
//   {
//     path: "/services/:slug",
//     component: <ServicesDetails />,
//   },
//   {
//     path: "/services/:slug/sub-service/:subSlug",
//     component: <SubserviceDetails />,
//   },
//   {
//     path: "/services/:slug/sub-service/:subSlug/:subSubSlug",
//     component: <SubSubService />,
//   },
  
//   // Blog routes with SEO-friendly URLs
//   {
//     path: "/blog-list",
//     component: <BlogList />,
//   },
//   {
//     path: "/blog/:slug",
//     component: <BlogDetails />,
//   },
  
//   // Article routes with SEO-friendly URLs
//   {
//     path: "/all-article",
//     component: <ArticlesPage />,
//   },
//   {
//     path: "/article/:slug",
//     component: <UserarticleDetails />,
//   },
  
//   // Legacy support (optional - redirects from ID to slug)
//   {
//     path: "/blog/id/:id",
//     component: <BlogDetails />,
//   },
//   {
//     path: "/article/id/:id",
//     component: <UserarticleDetails />,
//   },
//   {
//     path: "/service-details/:id",
//     component: <ServicesDetails />,
//   },
//   {
//     path: "/sub-service-details/:id",
//     component: <SubserviceDetails />,
//   },
//   {
//     path: "/sub-subservice-details/:id",
//     component: <SubSubService />,
//   },
// ];